import { generateText } from "@tiptap/core";
import { ReactComponent as ArrowRight } from "../../Assets/angle-right-solid.svg";
import { useConfigStore } from "../../Stores/Config";
import { Article } from "../../Stores/News";
import { useRouterStore } from "../../Stores/Router";
import { activateOnKey } from "../../Helper/a11y";
import {
  resolveLocalizedContent,
  resolveLocalizedString,
} from "../../Helper/LocalizedValue";
import "./NewsCard.scss";
import { ExtensionKit } from "../tiptap/extenstions/extension-kit";

function NewsCard({ news }: { news: Article }) {
  const routerStore = useRouterStore();
  const configStore = useConfigStore();

  if (!news) {
    return null;
  }

  // Subject/message may arrive as unresolved localized objects from older
  // API-created news — resolve to plain values so React never receives an
  // object child (#143258).
  const currentLanguage = configStore.getCurrentLanguage();
  const subject = resolveLocalizedString(news.subject, currentLanguage);
  const messageContent = resolveLocalizedContent(news.message, currentLanguage);

  var previewText = "";
  try {
    if (messageContent) {
      previewText = generateText(messageContent, [...ExtensionKit()]);
    }
  } catch (error) {
    console.log(error);
  }

  return (
    <div
      className="news-card"
      role="button"
      tabIndex={0}
      aria-label={subject}
      onClick={() => {
        routerStore.pushPage("newsdetails", { id: news.id });
      }}
      onKeyDown={activateOnKey(() => {
        routerStore.pushPage("newsdetails", { id: news.id });
      })}
    >
      {news.coverImageUrl && news.coverImageUrl.length > 0 && (
        <img className="news-card-image" src={news.coverImageUrl} alt="" />
      )}
      <div className="news-card-content">
        <div className="news-card-content-content">
          <div className="news-card-content-title">
            {news?.config?.pinned && "📌 "}
            {subject}
          </div>
          <div className="news-card-content-meta">{previewText}</div>
        </div>
        <ArrowRight className="news-card-content-show-details" />
      </div>
    </div>
  );
}

export default NewsCard;
